// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__1vhXN","amount":"Amount_amount__3QkXR","tip":"Amount_tip__1uprL","tipHeader":"Amount_tipHeader__1rvX3","tipsWrap":"Amount_tipsWrap__38Q1v"};